<script lang="ts">
	import type { Snippet } from 'svelte'

	interface Props {
		logo: Snippet
		title: Snippet
		children: Snippet
	}

	let { logo, title, children }: Props = $props()
</script>

<svelte:head>
	<title>Error</title>
</svelte:head>

<div class="flex h-screen w-screen items-center justify-center">
	<div class="flex flex-col gap-10">
		{@render logo()}
		<div class="bg-dark rounded-2xl p-10 text-white shadow-2xl">
			<h1 class="text-xl">
				{@render title()}
			</h1>
			<div class="mt-10"></div>
			{#if children}
				{@render children()}
			{:else}
				<p>
					Go to:
					<br />
					<a class="underline hover:no-underline" href="/">Dashboard</a>
				</p>
			{/if}
		</div>
	</div>
</div>
